module.exports = __webpack_public_path__ + "static/credit-card-group-b35d1638301fb72202a1cbabadbbe6c4.png";